import { c as _c } from "react/compiler-runtime";
import { ListingCardShell, ListingCardImage, ListingCardContent, CategoryTags } from "../parts";
import type { VisualType } from "@/lib/types";
export function PromoCard(t0) {
  const $ = _c(23);
  const {
    visual,
    title,
    href,
    campaignLabel,
    storeName,
    dateLabel,
    className,
    imageSizes,
    imageCropAspect,
    isLogo
  } = t0;
  let t1;
  if ($[0] !== campaignLabel) {
    t1 = campaignLabel ? <CategoryTags categories={[campaignLabel]} /> : undefined;
    $[0] = campaignLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== imageCropAspect || $[3] !== imageSizes || $[4] !== isLogo || $[5] !== t1 || $[6] !== visual) {
    t2 = <ListingCardImage visual={visual} overlay={t1} sizes={imageSizes} cropAspect={imageCropAspect} isLogo={isLogo} />;
    $[2] = imageCropAspect;
    $[3] = imageSizes;
    $[4] = isLogo;
    $[5] = t1;
    $[6] = visual;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== title) {
    t3 = <p className="w-full typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</p>;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== storeName) {
    t4 = storeName && <p className="typography-component-xs-regular text-text-secondary desktop:typography-component-sm-regular">{storeName}</p>;
    $[10] = storeName;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== dateLabel) {
    t5 = dateLabel && <p className="typography-component-xs-regular text-text-secondary">{dateLabel}</p>;
    $[12] = dateLabel;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <ListingCardContent gapClass="gap-1">{t3}{t4}{t5}</ListingCardContent>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== className || $[19] !== href || $[20] !== t2 || $[21] !== t6) {
    t7 = <ListingCardShell href={href} gapClass="gap-3 desktop:gap-4" className={className}>{t2}{t6}</ListingCardShell>;
    $[18] = className;
    $[19] = href;
    $[20] = t2;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}